// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 15:58:07

export default {
  "id": "fish-shooting-fish-hunter",
  "slug": "fish-shooting-fish-hunter",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/00f86f37c5d145678e9c41edd5980492-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/00f86f37c5d145678e9c41edd5980492/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Fish Shooting Fish Hunter",
      "description": "Want to begin a fun and relaxing fishing adventure? In Fish Shooting - Fish Hunter, you’ll become a fishing master. Use your skills and quick reflexes to catch various fish while enjoying a laid-back casual experience!",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Adventure",
        "Simulation"
      ],
      "tags": [
        "fishing",
        "relaxing",
        "supermarket"
      ]
    },
    "zh-CN": {
      "title": "鱼类射击鱼猎人",
      "description": "想要开始一段轻松愉快的钓鱼冒险吗？在《鱼射击 - 鱼猎人》中，你将成为钓鱼大师。运用你的技巧和敏捷的反应，捕捉各种鱼类，同时享受轻松休闲的游戏体验！",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "冒险",
        "模拟"
      ],
      "tags": [
        "钓鱼",
        "放松",
        "超市"
      ]
    },
    "zh-TW": {
      "title": "捕魚打魚獵人",
      "description": "想開始一場愉悅放鬆的釣魚冒險嗎？在《釣魚射擊 - 魚獵人》中，你將成為釣魚大師。運用你的技巧和敏捷反應，捕捉各種魚類，並享受放鬆的休闲體驗！",
      "instructions": "滑鼠點擊或觸控以遊玩",
      "genres": [
        "冒險",
        "模擬"
      ],
      "tags": [
        "釣魚",
        "放鬆",
        "超市"
      ]
    },
    "zh-HK": {
      "title": "魚射魚魚獵手",
      "description": "想開始一段愉悅輕鬆的釣魚冒險嗎？在《釣魚射擊 - 魚獵人》中，你將成為釣魚高手。運用你的技巧和快速反應，捕捉各式各樣的魚類，享受這段悠閒的隨意體驗！",
      "instructions": "滑鼠點擊或觸控遊玩",
      "genres": [
        "冒險",
        "模擬"
      ],
      "tags": [
        "釣魚",
        "放鬆",
        "超級市場"
      ]
    },
    "ja": {
      "title": "魚射魚ハンター",
      "description": "楽しいリラックスした釣りアドベンチャーを始めたいですか？「Fish Shooting - Fish Hunter」で釣りマスターになるでしょう。あなたのスキルと素早い反応を使って、さまざまな魚を捕まえながらリラックスしたカジュアルな体験を楽しみましょう！",
      "instructions": "マウスクリックまたはタップで遊ぶ",
      "genres": [
        "アドベンチャー",
        "シミュレーション"
      ],
      "tags": [
        "釣り",
        "リラックス",
        "スーパーマーケット"
      ]
    },
    "ko": {
      "title": "어장 사냥어족 사냥꾼",
      "description": "fun하고 쉬운angling 모험을 시작해보고 싶어요? Fish Shooting - Fish Hunter에서는 어업 마스터가 됩니다. 자신의 기술과 신속한 반응력을 사용하여 다양한 물고기를 잡으며 쉬운 캐주얼 경험을 즐겨보세요!",
      "instructions": "마우스 클릭 또는 탭하여 게임 시작",
      "genres": [
        "모험",
        "시뮬레이션"
      ],
      "tags": [
        "angling",
        "relaxation",
        "supermarket"
      ]
    },
    "fr": {
      "title": "Chasse aux poissons pour tireurs de poissons",
      "description": "Souhaitez-vous commencer une aventure de pêche amusante et relaxante ? Dans Fish Shooting - Fish Hunter, vous deviendrez un maître de la pêche. Utilisez vos compétences et vos réflexes rapides pour attraper divers poissons tout en profitant d'une expérience détendue et casual !",
      "instructions": "Clic ou tapotez pour jouer",
      "genres": [
        "Aventure",
        "Simulation"
      ],
      "tags": [
        "Pêche",
        "détente",
        "supermarché"
      ]
    }
  }
};
